export const isMiracleEar = (siteId?: number) => {
    return siteId === 12;
};
